import { formatCurrencyAmount } from "./formatCurrencyAmount";

// One line per currency and flow that needs a person, with what to do about
// it. Nothing here is a partner conversion: the two sides of this check are
// both inside Novacrust, so the fix is to find and complete the missed
// movement, not to convert at a partner.
export const investigateItems = (rows) => {
  const items = [];
  for (const r of rows) {
    const u = r.unmirrored;
    if (u.conversionCount > 0 && (u.mirrorFailureReasons ?? []).length > 0)
      items.push({
        key: `${r.currency}-conv-reasons`,
        currency: r.currency,
        text: `Why conversions are still not mirrored: ${u.mirrorFailureReasons.map((f) => `${f.reason} (${f.count})`).join("; ")}.`,
      });
    if ((u.conversionDrift?.shortCount ?? 0) > 0)
      items.push({
        key: `${r.currency}-drift`,
        currency: r.currency,
        text: `${u.conversionDrift.shortCount} mirrored conversion(s) credited the house merchant ${formatCurrencyAmount(u.conversionDrift.shortAmount, r.currency)} less than the consumer received (the rate moved between the two steps).`,
      });
    if (u.conversionCount > 0)
      items.push({
        key: `${r.currency}-conv`,
        currency: r.currency,
        text: `${u.conversionCount} consumer conversion(s) have no house-merchant counterpart (net ${formatCurrencyAmount(u.conversionNet, r.currency)}). These should have been mirrored automatically since 4 October; check why.`,
      });
    if (u.septlyDepositsCredited.count > 0)
      items.push({
        key: `${r.currency}-septly`,
        currency: r.currency,
        text: `${u.septlyDepositsCredited.count} Septly deposit(s) (${formatCurrencyAmount(u.septlyDepositsCredited.amount, r.currency)}) credited to consumers but missing on the house merchant. Run the Septly backfill (dry run first).`,
      });
    if (u.septlyDepositsHeld.count > 0)
      items.push({
        key: `${r.currency}-held`,
        currency: r.currency,
        text: `${u.septlyDepositsHeld.count} held Septly deposit(s) have no house-merchant manual-review row, so they are invisible on the merchant page. The same backfill adds them.`,
      });
    if (u.oneSidedPayouts.count > 0)
      items.push({
        key: `${r.currency}-payout`,
        currency: r.currency,
        text: `${u.oneSidedPayouts.count} withdrawal(s) (${formatCurrencyAmount(u.oneSidedPayouts.amount, r.currency)}) were debited from the consumer but never reached the business side. See Orphaned Payouts.`,
      });
    if (u.declinedAfterDispatch.count > 0)
      items.push({
        key: `${r.currency}-declined`,
        currency: r.currency,
        text: `${u.declinedAfterDispatch.count} payout(s) (${formatCurrencyAmount(u.declinedAfterDispatch.amount, r.currency)}) were declined and refunded to the consumer after a provider payout existed, so the house merchant is still debited. Check each at the provider before correcting.`,
      });
  }
  return items;
};
